import React from "react";
import { createPortal } from "react-dom";
import { FaTimes, FaUserCheck } from "react-icons/fa";

const ReactivatePatientModal = ({
  patient,
  onClose,
  onConfirm,
  isSubmitting,
}) => {
  if (!patient) return null;

  return createPortal(
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.45)",
        zIndex: 1070,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          width: "440px",
          maxWidth: "100%",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.18)",
          overflow: "hidden",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        <div
          style={{
            backgroundColor: "#0A3652",
            padding: "18px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3
            style={{
              margin: 0,
              fontSize: "16px",
              fontWeight: 700,
              color: "#FFFFFF",
            }}
          >
            Reactivate Patient
          </h3>
          <button
            type="button"
            onClick={onClose}
            disabled={isSubmitting}
            style={{
              background: "none",
              border: "none",
              cursor: isSubmitting ? "not-allowed" : "pointer",
              color: "#FFFFFF",
              padding: "2px",
              display: "flex",
              alignItems: "center",
              opacity: isSubmitting ? 0.6 : 1,
            }}
          >
            <FaTimes size={16} />
          </button>
        </div>

        <div style={{ padding: "24px" }}>
          <div
            style={{
              display: "flex",
              gap: "14px",
              alignItems: "flex-start",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: "#ECFDF5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <FaUserCheck size={18} color="#27B99A" />
            </div>
            <div>
              <p
                style={{
                  margin: "0 0 8px",
                  fontSize: "15px",
                  fontWeight: 600,
                  color: "#1F2937",
                  lineHeight: 1.5,
                }}
              >
                Reactivate{" "}
                <span style={{ color: "#064260" }}>{patient.name}</span>?
              </p>
              <p
                style={{
                  margin: 0,
                  fontSize: "13px",
                  color: "#6B7280",
                  lineHeight: 1.6,
                }}
              >
                This patient will return to the Active registry with status{" "}
                <strong>Intake</strong>. Historical records will remain
                available.
              </p>
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#F9FAFB",
              border: "1px solid #E5E7EB",
              borderRadius: "8px",
              padding: "14px 16px",
              marginBottom: "24px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "13px",
                marginBottom: "8px",
              }}
            >
              <span style={{ color: "#6B7280" }}>Inactive Reason</span>
              <span style={{ color: "#1F2937", fontWeight: 600 }}>
                {patient.inactiveReason || "—"}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "13px",
              }}
            >
              <span style={{ color: "#6B7280" }}>Inactive Date</span>
              <span style={{ color: "#1F2937", fontWeight: 600 }}>
                {patient.inactiveDate || "—"}
              </span>
            </div>
          </div>

          <div style={{ display: "flex", gap: "12px" }}>
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              style={{
                flex: 1,
                padding: "12px 16px",
                border: "1px solid #E5E7EB",
                borderRadius: "8px",
                backgroundColor: "#FFFFFF",
                color: "#374151",
                fontSize: "14px",
                fontWeight: 600,
                cursor: isSubmitting ? "not-allowed" : "pointer",
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isSubmitting}
              style={{
                flex: 1,
                padding: "12px 16px",
                border: "none",
                borderRadius: "8px",
                backgroundColor: isSubmitting ? "#86EFAC" : "#27B99A",
                color: "#FFFFFF",
                fontSize: "14px",
                fontWeight: 600,
                cursor: isSubmitting ? "not-allowed" : "pointer",
              }}
            >
              {isSubmitting ? "Reactivating..." : "Reactivate Patient"}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ReactivatePatientModal;
